import {
  FontWeight, getTypography, ThemedFunctor, TypographyName,
} from '@doveit/bricks';
import { css } from 'styled-components';

export const container: ThemedFunctor = ({ theme }) => css`
  display: flex;
  align-items: center;
  width: 100%;
  border: 1px solid ${theme.color.border.neutral.default.high};
  border-radius: ${theme.remSize[75]};
  overflow: hidden;
`;

export const preview: ThemedFunctor = () => css`
  width: 7.5rem;
  flex-shrink: 0;
  cursor: pointer;
`;

export const info: ThemedFunctor = ({ theme }) => css`
  display: flex;
  flex-direction: column;
  gap: ${theme.remSize[75]};
  flex: 1 0 0;
  min-width: 0;
  padding: ${theme.remSize[200]};
`;

export const title: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.BODY)}
  font-weight: ${FontWeight.MEDIUM};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
